import { LINGERS_LOCAL_STORAGE_KEY, OLD_USER_ID_KEY, DATA_OBJECT_KEY } from 'app/constants/localStorageKeys'

export const detectBrowser = () => {
  var ua = navigator.userAgent,
    tem,
    M = ua.match(/(opera|Chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || []
  if (/trident/i.test(M[1])) {
    tem = /\brv[ :]+(\d+)/g.exec(ua) || []
    return { name: 'IE', version: tem[1] || '' }
  }
  if (M[1] === 'Chrome') {
    tem = ua.match(/\bOPR|Edge\/(\d+)/)
    if (tem != null) {
      return { name: 'Opera', version: tem[1] }
    }
  }
  M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?']
  if ((tem = ua.match(/version\/(\d+)/i)) != null) {
    M.splice(1, 1, tem[1])
  }
  return {
    name: M[0],
    ver: M[1],
  }
}

export const detectOs = () => {
  let os = 'Unknown OS'
  let mobile = false
  if (navigator.userAgent.indexOf('Win') !== -1) os = 'Windows'
  if (navigator.userAgent.indexOf('Mac') !== -1) os = 'Macintosh'
  if (navigator.userAgent.indexOf('Linux') !== -1) os = 'Linux'
  if (navigator.userAgent.indexOf('Android') !== -1) {
    os = 'Android'
    mobile = true
  }
  if (navigator.userAgent.indexOf('like Mac') !== -1) {
    os = 'mac'
    mobile = true
  }
  return {
    os,
    mobile,
  }
}

export const getUserTokenKey = () => `RC_USER#${window.parent.RAYCHAT_TOKEN}`

export const getUserToken = () => {
  try {
    const userTokenKey = getUserTokenKey()
    return localStorage.getItem(userTokenKey) || localStorage.getItem(OLD_USER_ID_KEY)
  } catch (error) {
    console.error('LocalStorage access failed:', error)
    return null
  }
}

export const removeAllUserDataFromStorage = () => {
  const userTokenKey = getUserTokenKey()
  const raychatKeys = [DATA_OBJECT_KEY, OLD_USER_ID_KEY, LINGERS_LOCAL_STORAGE_KEY, userTokenKey]

  for (let key of raychatKeys) {
    localStorage.removeItem(key)
  }
}

export const isLocalStorageAvailable = () => {
  try {
    const testKey = '__test__'
    localStorage.setItem(testKey, testKey)
    localStorage.removeItem(testKey)
    return true
  } catch {
    return false
  }
}
